import React from 'react'
import PropTypes from 'prop-types';

import { Route } from "react-router-dom";

import { GenericScene } from 'scenes';

class PublicRoute extends React.Component {

  render() {
    //Extract component and the rest of props
    const { component: Content, path, exact, headless, ...rest } = this.props;

    return (
      <Route path={path} exact={exact} render={(props) => {

        return (
         /* Render generic scene with sub content */
        <GenericScene headless={headless}>
          <Content {...props} {...rest} />
        </GenericScene>
        );
      }
      }/>
    )
  }
}

PublicRoute.propTypes = {
  component: PropTypes.element.isRequired
};

export default PublicRoute;
